<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      row-key="Id"
      border
      lazy
      :load="load"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="index" width="80"></el-table-column>
      <el-table-column label="菜单/按钮" width="200">
        <template slot-scope="scope">
          <i class="fa" :class="scope.row.Icon"></i>

          {{ field(scope.row.Name) }}
        </template>
      </el-table-column>
      <el-table-column prop="Code" label="路由地址" width></el-table-column>
      <el-table-column prop="MName" label="API接口" width></el-table-column>
      <el-table-column
        prop="OrderSort"
        label="Sort"
        width
        sortable
      ></el-table-column>
      <el-table-column prop="IsButton" label="是否按钮" width="100">
        <template slot-scope="scope">
          <el-tag
            :type="!scope.row.IsButton ? 'success' : 'danger'"
            disable-transitions
            >{{ !scope.row.IsButton ? "否" : "是" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="Func" label="按钮事件" width></el-table-column>
      <el-table-column prop="IsHide" label="是否隐藏" width="100">
        <template slot-scope="scope">
          <el-tag
            :type="!scope.row.IsHide ? 'success' : 'danger'"
            disable-transitions
            >{{ !scope.row.IsHide ? "否" : "是" }}</el-tag
          >
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      :title="$t('edit')"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" label-width="130px" ref="editForm">
        <LangTabs>
          <template v-slot:main="slot">
            <el-form-item
              :label="$t('Permission.Name')"
              :prop="'Name.' + slot.langkey"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Permission.Name'),
              }"
            >
              <el-input v-model="editForm.Name[slot.langkey]"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Permission.Code')"
              prop="Code"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Permission.Code'),
              }"
            >
              <el-tooltip placement="top">
                <div slot="content">
                  如果是目录，请填‘-’字符
                  <br />如果是按钮，请输入空格即可
                  <br />如果是外链，请带上协议，比如 https://www.baidu.com
                  <br />
                </div>
                <el-input v-model="editForm.Code"></el-input>
              </el-tooltip>
            </el-form-item>
            <el-form-item
              :label="$t('Permission.Description')"
              prop="Description"
            >
              <el-input v-model="editForm.Description"></el-input>
            </el-form-item>
            <el-form-item label="Icon" prop="Icon">
              <el-input v-model="editForm.Icon"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Enabled')">
              <el-switch v-model="editForm.Enabled"></el-switch>
            </el-form-item>
            <el-form-item label="Sort" prop="OrderSort">
              <el-input
                type="number"
                v-model.number="editForm.OrderSort"
                auto-complete="off"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="IsButton"
              :label="$t('Permission.IsButton')"
              width
              sortable
            >
              <el-switch v-model="editForm.IsButton"></el-switch>
            </el-form-item>
            <el-form-item :label="$t('Permission.Func')" prop="Func">
              <el-select
                v-model="editForm.Func"
                :placeholder="$t('Permission.Func')"
                prop="Func"
                filterable
                allow-create
                clearable
              >
                <el-option
                  key="searchList"
                  label="searchList"
                  value="searchList"
                ></el-option>
                <el-option
                  key="getList"
                  label="getList"
                  value="getList"
                ></el-option>
                <el-option
                  key="handleAdd"
                  label="handleAdd"
                  value="handleAdd"
                ></el-option>
                <el-option
                  key="handleEdit"
                  label="handleEdit"
                  value="handleEdit"
                ></el-option>
                <el-option
                  key="handleDel"
                  label="handleDel"
                  value="handleDel"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              prop="IsHide"
              :label="$t('Permission.IsHide')"
              width
              sortable
            >
              <el-switch v-model="editForm.IsHide"></el-switch>
            </el-form-item>
            <el-form-item
              prop="PidArr"
              :label="$t('Permission.PidArr')"
              width
              sortable
            >
              <el-cascader
                style="width: 100%"
                v-model="editForm.PidArr"
                :options="options"
                filterable
                :props="{ checkStrictly: true, expandTrigger: 'hover' }"
              ></el-cascader>
            </el-form-item>
            <el-form-item
              prop="Mid"
              :label="$t('Permission.MName')"
              width
              sortable
            >
              <el-select
                style="width: 100%"
                v-model="editForm.Mid"
                placeholder="Select API"
              >
                <el-option :key="0" :value="0" :label="'No api'"></el-option>
                <el-option
                  v-for="item in modules"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.LinkUrl"
                >
                  <span style="float: left">{{ item.LinkUrl }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    item.Name
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </template>
          <template v-slot:other="slot">
            <el-form-item :label="$t('Permission.Name')">
              <el-input v-model="editForm.Name[slot.item.key]"></el-input>
            </el-form-item>
          </template>
        </LangTabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      :title="$t('add')"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="130px" ref="addForm">
        <LangTabs>
          <template v-slot:main="slot">
            <el-form-item
              :label="$t('Permission.Name')"
              :prop="'Name.' + slot.langkey"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Permission.Name'),
              }"
            >
              <el-input v-model="addForm.Name[slot.langkey]"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Permission.Code')"
              prop="Code"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Permission.Code'),
              }"
            >
              <el-tooltip placement="top">
                <div slot="content">
                  如果是目录，请填‘-’字符
                  <br />如果是按钮，请输入空格即可
                  <br />如果是外链，请带上协议，比如 https://www.baidu.com
                  <br />
                </div>
                <el-input v-model="addForm.Code"></el-input>
              </el-tooltip>
            </el-form-item>
            <el-form-item
              :label="$t('Permission.Description')"
              prop="Description"
            >
              <el-input v-model="addForm.Description"></el-input>
            </el-form-item>
            <el-form-item label="Icon" prop="Icon">
              <el-input v-model="addForm.Icon"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Enabled')">
              <el-switch v-model="addForm.Enabled"></el-switch>
            </el-form-item>
            <el-form-item label="Sort" prop="OrderSort">
              <el-input
                v-model.number="addForm.OrderSort"
                type="number"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="IsButton"
              :label="$t('Permission.IsButton')"
              sortable
            >
              <el-switch v-model="addForm.IsButton"></el-switch>
            </el-form-item>
            <el-form-item :label="$t('Permission.Func')" prop="Func">
              <el-select
                v-model="addForm.Func"
                :placeholder="$t('Permission.Func')"
                prop="Func"
                filterable
                allow-create
                clearable
              >
                <el-option
                  key="searchList"
                  label="searchList"
                  value="searchList"
                ></el-option>
                <el-option
                  key="getList"
                  label="getList"
                  value="getList"
                ></el-option>
                <el-option
                  key="handleAdd"
                  label="handleAdd"
                  value="handleAdd"
                ></el-option>
                <el-option
                  key="handleEdit"
                  label="handleEdit"
                  value="handleEdit"
                ></el-option>
                <el-option
                  key="handleDel"
                  label="handleDel"
                  value="handleDel"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="IsHide" :label="$t('Permission.IsHide')">
              <el-switch v-model="addForm.IsHide"></el-switch>
            </el-form-item>
            <el-form-item prop="PidArr" :label="$t('Permission.PidArr')">
              <el-cascader
                style="width: 100%"
                v-model="addForm.PidArr"
                :options="options"
                filterable
                :props="{ checkStrictly: true, expandTrigger: 'hover' }"
              ></el-cascader>
            </el-form-item>
            <el-form-item prop="Mid" :label="$t('Permission.MName')">
              <el-select
                style="width: 100%"
                v-model="addForm.Mid"
                placeholder="Select API"
              >
                <el-option :key="0" :value="0" label="No api"></el-option>
                <el-option
                  v-for="item in modules"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.LinkUrl"
                >
                  <span style="float: left">{{ item.LinkUrl }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    item.Name
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </template>
          <template v-slot:other="slot">
            <el-form-item :label="$t('Permission.Name')">
              <el-input v-model="addForm.Name[slot.item.key]"></el-input>
            </el-form-item>
          </template>
        </LangTabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  getPermissionListPage,
  getPermissionTreeTable,
  removePermission,
  editPermission,
  addPermission,
  getPermissionTree,
  getModuleAllListPage,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      options: [],
      filters: {
        Name: "",
      },
      list: [],
      modules: [], //接口api列表
      statusList: [
        { Name: "激活", value: true },
        { Name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      //编辑界面数据
      editForm: {
        Name: {},
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      //新增界面数据
      addForm: {
        Name: {},
      },
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getPermissions();
    },
    load(tree, treeNode, resolve) {
      let para = {
        f: tree.Id,
        key: this.filters.Name,
      };
      getPermissionTreeTable(para).then((res) => {
        resolve(res.data.response);
      });
    },
    //获取列表
    getPermissions() {
      let para = {
        key: this.filters.Name,
      };
      this.listLoading = true;
      getPermissionTreeTable(para).then((res) => {
        this.list = res.data.response;
        this.listLoading = false;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removePermission(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getPermissions();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      let that = this;
      that.editLoading = true;
      this.editFormVisible = true;
      this.options = [];
      let para = { pid: row.Id, lang: this.$i18n.locale };
      getPermissionTree(para).then((res) => {
        this.options.push(res.data.response);
        that.editForm = Object.assign({}, this.clone(row));
        that.editLoading = false;
      });
    },
    //显示新增界面
    handleAdd() {
      this.options = [];
      this.addFormVisible = true;
      this.addForm = {
        PidArr: [],
        Name: {},
        Code: "",
        OrderSort: 0,
        Description: "",
        Enabled: true,
        Icon: "",
        IsButton: false,
        IsHide: false,
      };

      let para = { pid: 0, lang: this.$i18n.locale };
      getPermissionTree(para).then((res) => {
        this.options.push(res.data.response);
      });
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            let para = Object.assign({}, this.editForm);

            para.ModifyTime = util.formatDate.format(new Date(), "yyyy-MM-dd");

            para.Pid = para.PidArr.pop();

            if (para.Id == para.Pid) {
              this.$message({
                message: "警告，父节点不能是自己！",
                type: "error",
              });

              this.editLoading = false;
              return;
            }

            editPermission(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              this.editLoading = false;
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getPermissions();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);
            para.IsDeleted = false;

            para.Pid = para.PidArr.pop();

            addPermission(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              this.addLoading = false;
              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getPermissions();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
  },
  mounted() {
    this.getPermissions();

    getModuleAllListPage().then((res) => {
      this.modules = res.data.response;
    });

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
</style>
